import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
  discountsOfferList: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createDiscountsOffered: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  updateDiscountsOffered: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  deleteTool: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  renderDiscountsOfferedListData : [] 
};

export const DiscountsOfferedReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GET_DISCOUNT_OFFERED:
      return {
        ...newState,
        discountsOfferList: { ...newState.discountsOfferList, isLoading: true, hasError: false },
      };
    case actionTypes.GET_DISCOUNT_OFFERED_SUCCESS:
      return {
        ...newState,
        discountsOfferList: { ...newState.discountsOfferList, data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_DISCOUNT_OFFERED_FAILURE:
      return {
        ...newState,
        discountsOfferList: { ...newState.discountsOfferList, data: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.CREATE_DISCOUNT_OFFERED:
      return {
        ...newState,
        createDiscountsOffered: { ...newState.createDiscountsOffered, isLoading: true, hasError: false },
      };
    case actionTypes.CREATE_DISCOUNT_OFFERED_SUCCESS:
      return {
        ...newState,
        createDiscountsOffered: { ...newState.createDiscountsOffered, data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.CREATE_DISCOUNT_OFFERED_FAILURE:
      return {
        ...newState,
        createDiscountsOffered: { ...newState.createDiscountsOffered, data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.UPDATE_DISCOUNT_OFFERED:
      return {
        ...newState,
        updateDiscountsOffered: { ...newState.updateDiscountsOffered, isLoading: true, hasError: false },
      };
    case actionTypes.UPDATE_DISCOUNT_OFFERED_SUCCESS:
      return {
        ...newState,
        updateDiscountsOffered: { ...newState.updateDiscountsOffered, data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.UPDATE_DISCOUNT_OFFERED_FAILURE:
      return {
        ...newState,
        updateDiscountsOffered: { ...newState.updateDiscountsOffered, data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.DELETE_TOOL:
        return {
          ...newState,
          deleteTool: { ...newState.deleteTool, isLoading: true, hasError: false },
        };
      case actionTypes.DELETE_TOOL_SUCCESS:
        return {
          ...newState,
          deleteTool: { ...newState.deleteTool, data: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.DELETE_TOOL_FAILURE:
        return {
          ...newState,
          deleteTool: { ...newState.deleteTool, data: action.payload, isLoading: false, hasError: true },
        };
      case actionTypes.RENDER_DISCOUNT_OFFERED_LIST_DATA:
        return{
          ...newState,
          renderDiscountsOfferedListData:action.payload
        }

    default:
      return { ...newState };
  }
};
